module.exports = __webpack_public_path__ + "img/Ticto-1-es.944dfc8b.png";